import { render } from "./notaCredito.vue?vue&type=template&id=252d1b20"
import script from "./notaCredito.vue?vue&type=script&lang=js"
export * from "./notaCredito.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__